/* Ovarana hero slideshow.

   Stacked cross-fade (opacity) between slides - on auto-rotate AND on
   arrow / dot / swipe, matching figliving.com. No horizontal slide.
   Autoplay runs on a timer and pauses the moment the user hovers,
   focuses, swipes the hero, or tabs away from the page.

   Behaviour is pure class-toggling (.is-selected); the dissolve itself
   lives in section-ovarana-hero.css. Reads data-autoplay / data-speed
   from the section root. Multiple heroes on one page are independent. */
(function () {
  function initHero(root) {
    if (root.dataset.ovhReady === 'true') return;
    root.dataset.ovhReady = 'true';

    var slides = Array.prototype.slice.call(root.querySelectorAll('.ovarana-hero__slide'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('.ovarana-hero__dot'));
    if (slides.length <= 1) return;

    var idx = 0;
    var timer = null;
    var speed = parseFloat(root.getAttribute('data-speed')) || 6;
    var dwell = speed * 1000;
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var reduce = window.matchMedia('(prefers-reduced-motion:reduce)').matches;

    function show(n) {
      idx = (n + slides.length) % slides.length;
      slides.forEach(function (sl, i) {
        var on = i === idx;
        sl.classList.toggle('is-selected', on);
        if (on) {
          sl.removeAttribute('aria-hidden');
        } else {
          sl.setAttribute('aria-hidden', 'true');
        }
        var cta = sl.querySelector('.ovarana-hero__cta');
        if (cta) cta.tabIndex = on ? 0 : -1;
      });
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === idx);
        d.setAttribute('aria-selected', i === idx ? 'true' : 'false');
      });
    }
    function next() { show(idx + 1); }
    function prev() { show(idx - 1); }
    function play() {
      if (!autoplay || reduce) return;
      stop();
      timer = setInterval(next, dwell);
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    var nextBtn = root.querySelector('.ovarana-hero__arrow--next');
    var prevBtn = root.querySelector('.ovarana-hero__arrow--prev');
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); play(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); play(); });
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { show(i); play(); });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', play);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', play);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else { play(); }
    });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); next(); play(); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); prev(); play(); }
    });

    /* pointer swipe - also cross-fades. Resilient to a release or cancel
       outside the hero (e.g. a vertical touch-scroll) so autoplay can't
       get stuck off. */
    var x0 = null;
    function endSwipe(e) {
      if (x0 === null) { play(); return; }
      var dx = (e.clientX != null ? e.clientX : x0) - x0;
      x0 = null;
      if (Math.abs(dx) > 40) { if (dx < 0) { next(); } else { prev(); } }
      play();
    }
    root.addEventListener('pointerdown', function (e) { x0 = e.clientX; stop(); });
    root.addEventListener('pointerup', endSwipe);
    root.addEventListener('pointercancel', endSwipe);
    root.addEventListener('pointerleave', function (e) { if (x0 !== null) endSwipe(e); });

    show(0);
    play();
  }

  function initAll() {
    document.querySelectorAll('.ovarana-hero').forEach(initHero);
  }

  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', initAll);
  }

  /* Theme editor: a reloaded section arrives with a fresh DOM. */
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.ovarana-hero');
    if (root) initHero(root);
  });
})();
